import React from "react";
import { Moon, Sun } from "lucide-react";
import { getActiveTheme, setTheme, useTheme } from "campaign-builder/theme";

/**
 * Light/dark toggle for the redesigned builder — same behavior as the
 * platform-next Topbar toggle (flips the `dark` class on <html>, re-pointing
 * the `--sds-*` tokens), backed by the builder's own theme store since the
 * builder runs on a separate origin from the platform.
 */
export const ThemeToggle = () => {
  const theme = useTheme();
  const isDark = theme === "dark";
  return (
    <button
      type="button"
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      data-cypress-id="theme-toggle-button"
      onClick={() => setTheme(getActiveTheme() === "dark" ? "light" : "dark")}
      className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border-0 bg-transparent text-muted-foreground hover:bg-slate-100 hover:text-foreground dark:hover:bg-muted"
    >
      {isDark ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
    </button>
  );
};
